/* Datei: src/pages/BlogAdmin/BlogEditor.js */
import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import axios from 'axios';
import 'react-quill/dist/quill.snow.css';
import { useParams, useNavigate } from 'react-router-dom';
import config from "../../config/config";
import { API_BASE_URL } from '../../config/config';

const BlogEditor = () => {
  const { articleId } = useParams(); // "new" oder eine existierende ID
  const navigate = useNavigate();
  const [originalContent, setOriginalContent] = useState('');
  const [editorContent, setEditorContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchAndTransform = async () => {
      if (articleId === "new") {
        setOriginalContent("<p>Neuer Artikel</p>");
        setEditorContent("<p>Neuer Artikel</p>");
        setLoading(false);
      } else {
        try {
          console.log("[BlogEditor] Lade vollständigen Originalartikel für Artikel-ID:", articleId);
          // Ruft den neuen Endpunkt auf, der den vollen Artikelinhalt extrahiert
          const fullRes = await axios.get(`${config.API_BASE_URL}/api/fetch-full-article/${articleId}`);
          if (!fullRes.data || !fullRes.data.fullText) {
            throw new Error("Kein vollständiger Artikelinhalt gefunden.");
          }
          setOriginalContent(fullRes.data.fullText);
          console.log("[BlogEditor] Vollständiger Originalartikel geladen.");
          console.log("[BlogEditor] Sende Inhalt zur Transformation...");
          const transformRes = await axios.post(`${config.API_BASE_URL}/api/transform-article`, { content: fullRes.data.fullText });
          if (!transformRes.data || !transformRes.data.transformedContent) {
            throw new Error("Transformation hat keinen Inhalt zurückgeliefert.");
          }
          setEditorContent(transformRes.data.transformedContent);
          console.log("[BlogEditor] Transformierter Inhalt erhalten.");
        } catch (error) {
          console.error("[BlogEditor] Fehler beim Laden/Transformieren des Artikels:", error);
          setMessage("Fehler beim Laden oder Transformieren des Artikels.");
        } finally {
          setLoading(false);
        }
      }
    };
    fetchAndTransform();
  }, [articleId]);

  const handleSave = async () => {
    try {
      console.log("[BlogEditor] Speichere bearbeiteten Artikel für Artikel-ID:", articleId);
      await axios.put(`${config.API_BASE_URL}/api/blog-articles/${articleId}`, { content: editorContent });
      setMessage("Artikel erfolgreich gespeichert!");
    } catch (error) {
      console.error("[BlogEditor] Fehler beim Speichern des Artikels:", error);
      setMessage("Fehler beim Speichern des Artikels.");
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Soll dieser Artikel wirklich gelöscht werden?")) {
      try {
        await axios.delete(`${config.API_BASE_URL}/api/blog-articles/${articleId}`);
        setMessage("Artikel gelöscht!");
        navigate("/dashboard/blog");
      } catch (error) {
        console.error("[BlogEditor] Fehler beim Löschen:", error);
        setMessage("Fehler beim Löschen des Artikels.");
      }
    }
  };

  const handlePublish = async () => {
    try {
      await axios.put(`${config.API_BASE_URL}/api/blog-articles/${articleId}/publish`);
      setMessage("Artikel publiziert!");
      navigate("/dashboard/blog");
    } catch (error) {
      console.error("[BlogEditor] Fehler beim Publizieren:", error);
      setMessage("Fehler beim Publizieren des Artikels.");
    }
  };

  const handleIgnore = async () => {
    try {
      await axios.put(`${config.API_BASE_URL}/api/blog-articles/${articleId}/ignore`);
      setMessage("Artikel ignoriert!");
      navigate("/dashboard/blog");
    } catch (error) {
      console.error("[BlogEditor] Fehler beim Ignorieren:", error);
      setMessage("Fehler beim Ignorieren des Artikels.");
    }
  };

  if (loading) return <div>Lädt...</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', backgroundColor: '#000' }}>
      {/* Inline-Style, um den Editor-Text weiß darzustellen */}
      <style>{`
        .ql-editor {
          color: white;
          background-color: #000;
        }
      `}</style>
      <div style={{ display: 'flex', flex: 1 }}>
        {/* Linke Spalte: Originalartikel */}
        <div style={{ flex: 1, padding: '20px', overflowY: 'auto', borderRight: '1px solid #ccc' }}>
          <h2 style={{ color: 'white' }}>Originalartikel</h2>
          <div dangerouslySetInnerHTML={{ __html: originalContent }} style={{ color: 'white' }} />
        </div>
        {/* Rechte Spalte: Editor */}
        <div style={{ flex: 1, padding: '20px', display: 'flex', flexDirection: 'column' }}>
          <h2 style={{ color: 'white' }}>Bearbeiteter Artikel</h2>
          <ReactQuill 
            value={editorContent} 
            onChange={setEditorContent} 
            style={{ flex: 1, backgroundColor: '#000' }}
          />
        </div>
      </div>
      {/* Aktionen */}
      <div style={{ padding: '20px', borderTop: '1px solid #ccc', display: 'flex', gap: '20px', justifyContent: 'center' }}>
        <button onClick={handleSave} style={{ padding: '10px 20px', fontSize: '16px' }}>
          Speichern
        </button>
        <button onClick={handleDelete} style={{ padding: '10px 20px', fontSize: '16px', backgroundColor: 'red', color: 'white' }}>
          Löschen
        </button>
        <button onClick={handleIgnore} style={{ padding: '10px 20px', fontSize: '16px', backgroundColor: 'orange', color: 'white' }}>
          Ignorieren
        </button>
        <button onClick={handlePublish} style={{ padding: '10px 20px', fontSize: '16px', backgroundColor: 'green', color: 'white' }}>
          Publizieren
        </button>
      </div>
      {message && <div style={{ textAlign: 'center', padding: '10px', color: 'blue' }}>{message}</div>}
    </div>
  );
};

export default BlogEditor;
